import { config } from '../config';

/**
 * Hook to check if a feature is enabled
 * @param featureName - The name of the feature to check
 * @param defaultValue - The default value if the feature is not defined (default: false)
 * @returns true if the feature is enabled, false otherwise
 */
export function useFeature(featureName: string, defaultValue = false): boolean {
  const features = config.features as Record<string, boolean>;

  // Check if the feature exists in the config
  if (featureName in features) {
    return features[featureName] === true;
  }
  
  // Return default value if feature is not defined
  return defaultValue;
}

